import React, { Component } from "react";
import auth from "../components/auth";
import BackDrop from "../components/Backdrop/Backdrop";
import Error from "../components/ErrorBoundary";
import Entry from "../components/profileEntry";
import { url } from "../components/url";

export class Profile extends Component {
  state = {
    isShowLoader: true,
    profileDetails: []
  };
  componentDidMount() {
    this.loadProfile();
  }

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  loadProfile = () => {
    this.setState({ isShowLoader: true });
    let formData = JSON.stringify({
      name: "getProfile",
      param: {}
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.hasOwnProperty("error")) {
          alert(data.error.message);
          this.logout();
        } else {
          // console.log(data);
          this.setState({ profileDetails: data["0"], isShowLoader: false });
          // console.log(this.state.profileDetails)
        }
      })
      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error + "" === "TypeError: Failed to fetch") {
          alert(
            "Please check if the device is connected to stable cellular data plan or WiFi."
          );
        } else {
          console.log(error);
        }
      });
  };

  render() {
    let loading = (
      <BackDrop>
        <p>loading...</p>
      </BackDrop>
    );
    return (
      <div>
        <Error>
          {this.state.isShowLoader ? loading : null}
          <Entry heading={"Name"} value={this.state.profileDetails.name} />

          <Entry heading={"Email"} value={this.state.profileDetails.email} />

          <Entry
            heading={"Phone Number"}
            value={this.state.profileDetails.phone}
          />

          <Entry
            heading={"Department"}
            value={this.state.profileDetails.dept}
          />
          <Entry
            heading={"TaxPayers Registered (indv)"}
            value={this.state.profileDetails.count}
          />
          <Entry
            heading={"TaxPayers Registered (non_indv)"}
            value={this.state.profileDetails.count_non}
          />
        </Error>
      </div>
    );
  }
}

export default Profile;
